/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';

import {
	Label,
	FlexLayout,
	SVGIcon
} from '@ba/ba-ui-carbon-toolkit';
import '../../stylesheets/all.scss';
import delSwatch from '@ba/ba-graphics/dist/icons-js/delete_32';

const DEFAULT_FAVORITES = 12;


export default class Favorites extends Component {

	/**
		 * Create a view that will show the user his favorite colors, and allow him to choose and delete
		 * @param {array} options.updateColor - {Optional} callback when a favorite color is selected.
		 * @param {array} options.favoriteColors - {REQUIRED} Favorite colors previously saved
		 * @param {integer} options.numberOfFavorites - {Optional} Max number of favorites possible, by default 12.
	*/

	static propTypes = {
		updateColor: PropTypes.func,
		favoriteColors: PropTypes.array.isRequired,
		numberOfFavorites: PropTypes.number
	}

	constructor(props) {
		super(props);
		this.numberOfFavorites = props.numberOfFavorites ? props.numberOfFavorites : DEFAULT_FAVORITES;
		this.currentFavorite = null;
		this.state = {
			favoriteColors: props.favoriteColors
		};
	}

	onDeleteFavorite() {
		//last one
		let index = this.state.favoriteColors.length-1;
		if(this.currentFavorite){
			index = this.currentFavorite.getAttribute('favoriteIndex');
			this.deselectCurrentFavorite();
		}
		let colors = this.state.favoriteColors;
		colors.splice(index, 1);
		this.setState({
			favoriteColors: colors
		});
	}

	handleKeyDown(e, handler){
		if (e.which === 13 || e.which === 32){
			handler(e);
		}
	}

	deselectCurrentFavorite(){
		if (this.isFavoriteSelected()) {
			this.currentFavorite.classList.remove('selected');
			this.currentFavorite = null;
		}
	}

	isFavoriteSelected(){
		return !!this.currentFavorite;
	}

	updateSelectedColor(color){
		let colors = this.state.favoriteColors;
		colors[this.getSelectedIndex()] = color;
		this.setState({
			favoriteColors: colors
		});
	}

	getSelectedIndex() {
		if (this.isFavoriteSelected()) {
			return this.currentFavorite.getAttribute('favoriteIndex');
		}
	}

	getSelectedColor(){
		if (this.isFavoriteSelected()){
			return this.currentFavorite.getAttribute('value');
		}
	}

	selectFavorite(element) {
		if (element.target.classList.contains('selected')) {
			this.currentFavorite = null;
		}else{
			this.deselectCurrentFavorite();
			this.currentFavorite = element.target;
		}
		element.target.classList.toggle('selected');
		if(this.props.updateColor){
			this.props.updateColor(this.getSelectedColor());
		}
	}

	getFavoriteColors () {
		return this.state.favoriteColors;
	}

	getFavorite(i, color) {
		if(color){
			return <div className='favoriteBox filled' key={i} tabIndex='0' favoriteIndex={i} value={color} onKeyDown={e => this.handleKeyDown(e, this.selectFavorite.bind(this))} onClick={e => this.selectFavorite(e)} style={{ backgroundColor: color }}></div>;
		}else{
			return <div className='favoriteBox' key={i} favoriteIndex={i}></div>;
		}
	}

	generateFavorites() {
		//TODO Get CM colors
		const favorites = [];
		for (let i = 0; i < this.numberOfFavorites; i++) {
			let color = i < this.state.favoriteColors.length ? this.state.favoriteColors[i] : undefined;
			favorites.push(this.getFavorite(i, color));
		}
		return favorites;
	}

	render() {
		return (
			<FlexLayout className='favoriteColors'  direction='column'>
				<Label className='favoritesLabel' label={StringResources.get('favoritesLabel')}>
				</Label>
				<FlexLayout className='favoritesPicker' inline={true} direction='row'>
					{this.generateFavorites()}
					<SVGIcon className="deleteFavorite" size='small' iconId={delSwatch.id} tabIndex='0' onKeyDown={e => this.handleKeyDown(e, this.onDeleteFavorite.bind(this))} onClick={this.onDeleteFavorite.bind(this)}>
					</SVGIcon>
				</FlexLayout>
			</FlexLayout >
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Favorites.js